module.exports = __webpack_public_path__ + "fonts/fa-brands-400.ff496de9.woff2";